import AXIOS from "../services/axios";

export const getEventDetails = async (id) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/events/${id}`
    );
    response.data = data[0]; 
  } catch (err) {
    response.error = err.response || err;
  }
  return response;
};

export const getStateList = async () => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/events/state_list`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response || err;
  }
  return response;
};

export const getTimelineList = async (rootId) => {
  const response = { data: null, error: null };
  try {
    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/events/timeline/${rootId}`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response || err;
  }
  return response;
};

export const getTimelineDetail = async (sub_eventId, rootId) => {
  const response = { data: null, error: null };
  try {
    console.log("new :" , sub_eventId);

    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/events/${sub_eventId}?root_id=${rootId}`
    );
    response.data = data; 
  } catch (err) {
    response.error = err.response || err;
  }
  return response;
};

export const getEventsByDate = async (page = 1, start = "", end = "", state) => {
  const response = { data: null, error: null };
  try {
    const query = [
      `page=${page}`,
      state ? `state=${state}` : "",
      start ? `updated_at_after=${start}` : "",
      end ? `updated_at_before=${end}` : ""
    ].filter(Boolean).join("&");

    const { data } = await AXIOS.get(
      `${process.env.REACT_APP_API_PATH}/events/?${query}`
    );
    response.data = data;
  } catch (err) {
    response.error = err.response || err;
  }
  return response;
};